import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-103f8082"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-header" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","gap":"10px","flex-wrap":"wrap","margin-bottom":"10px"} }
const _hoisted_3 = { class: "flexAlign" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"13px","color":"#606266","margin-right":"5px"} }, "附件来源：", -1))
const _hoisted_5 = { class: "flexAlign" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("刷新")
const _hoisted_7 = { style: {"color":"#909399","font-size":"12px"} }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["title", "onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "link-tip" }, "（跳转 ›）", -1))
const _hoisted_11 = ["title"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode("关 闭")
const _hoisted_13 = { class: "my-header" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务详情", -1))
const _hoisted_15 = { class: "my-header" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("关 闭")
const _hoisted_17 = { class: "my-header" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "项目日志", -1))

import { ref, computed, nextTick } from 'vue';
import { apiName } from '@/api/api';
import { requestProjectAllFiles, requestTaskInfoById, requestProjectAllList } from '@/api/xmApi';
import { ElMessage } from 'element-plus';
import TaskDetails from '@/components/TaskDetails.vue';
import ProjectInfoEdit from '@/components/ProjectInfoEdit.vue';
import AddProjectlog from '@/components/AddProjectlog.vue';


export default /*#__PURE__*/_defineComponent({
  name: 'ProjectAllFiles',
  setup(__props, { expose }) {

const api = ref<string>(apiName)
const show = ref<boolean>(false)
const loading = ref<boolean>(false)
const files = ref<any[]>([])
const pname = ref<string>('')
const puuid = ref<string>('')
const fileSource = ref<string>('')
const keyword = ref<string>('')

const fileSources = computed(() => {
	const set: string[] = []
	files.value.forEach((f: any) => { if (f.source && set.indexOf(f.source) < 0) set.push(f.source) })
	return set
})
const filteredFiles = computed(() => {
	return files.value.filter((f: any) => {
		if (fileSource.value && f.source !== fileSource.value) return false
		const kw = (keyword.value || '').trim()
		if (kw && (f.name || '').indexOf(kw) < 0 && (f.desc || '').indexOf(kw) < 0) return false
		return true
	})
})
const load = () => {
	if (!puuid.value) return
	loading.value = true
	requestProjectAllFiles({ projectuuid: puuid.value }).then((res: any) => {
		loading.value = false
		files.value = (res.status === 1 && res.datalist) ? res.datalist : []
	})
}
// ===== 点击描述跳转到对应页面并定位 =====
const targetNameMap: any = {
	tasklog: '任务详情 - 对应任务日志',
	taskfile: '任务详情 - 任务附件',
	sign: '任务详情 - 签字流程节点附件',
	projectlog: '项目日志 - 对应日志',
	dc: '项目信息 - 数据收集（订单信息计划表）',
	projectinfo: '项目信息'
}
const targetName = (t: string): string => targetNameMap[t] || '对应位置'
// 项目信息缓存（uuid/code/projectname）
const curProject = ref<any>({})
const ensureProject = (): Promise<any> => {
	if (curProject.value && curProject.value.uuid) return Promise.resolve(curProject.value)
	return requestProjectAllList({}).then((res: any) => {
		const list = (res && res.datalist) || []
		curProject.value = list.find((p: any) => String(p.uuid) === String(puuid.value)) || {}
		return curProject.value
	})
}
// 任务详情
const taskShow = ref<boolean>(false)
const taskShowInner = ref<boolean>(false)
const taskForm = ref<any>({})
const focusTarget = ref<string>('')
const focusStepId = ref<any>('')
const focusLogId = ref<any>('')
const openTask = (row: any) => {
	requestTaskInfoById({ taskid: row.taskid }).then((res: any) => {
		if (res.status !== 1 || !res.datalist) { ElMessage.warning('未找到对应任务'); return }
		taskForm.value = res.datalist
		focusTarget.value = row.target || ''
		focusStepId.value = row.stepid || ''
		focusLogId.value = row.logid || ''
		taskShow.value = true
		taskShowInner.value = false
		nextTick(() => { taskShowInner.value = true })
	})
}
// 项目信息（数据收集）
const projectInfoShow = ref<boolean>(false)
const projectInfoRef = ref<any>(null)
const openProjectInfo = () => {
	ensureProject().then(() => {
		projectInfoShow.value = true
		// 组件挂载后触发加载（ProjectInfoEdit 不会自动加载，必须由父组件调用 load()）
		nextTick(() => {
			if (projectInfoRef.value) projectInfoRef.value.load()
		})
	})
}
// 项目日志
const projectLogShow = ref<boolean>(false)
const projectLogShowInner = ref<boolean>(false)
const focusProjectLogId = ref<any>('')
const openProjectLog = (row: any) => {
	ensureProject().then((p: any) => {
		if (!p || !p.uuid) { ElMessage.warning('未找到对应项目'); return }
		focusProjectLogId.value = row.logid || ''
		projectLogShow.value = true
		projectLogShowInner.value = false
		nextTick(() => { projectLogShowInner.value = true })
	})
}
const goTarget = (row: any) => {
	const t = String(row.target || '')
	if (t === 'tasklog' || t === 'taskfile' || t === 'sign') { openTask(row); return }
	if (t === 'projectlog') { openProjectLog(row); return }
	if (t === 'dc' || t === 'projectinfo') { openProjectInfo(); return }
	ElMessage.info('该附件暂不支持跳转定位')
}

// 供外部调用：打开某项目的所有附件
const open = (uuid: string, projectname: string) => {
	puuid.value = uuid || ''
	pname.value = projectname || ''
	fileSource.value = ''
	keyword.value = ''
	curProject.value = {}//切换项目时清空缓存，避免串项目
	show.value = true
	load()
}

expose({ open })

return (_ctx: any,_cache: any) => {
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((show).value = $event)),
      "show-close": false,
      "close-on-click-modal": false,
      width: "88%",
      top: "5vh",
      "append-to-body": ""
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, "所有附件 - " + _toDisplayString(pname.value), 1),
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (show.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_el_select, {
              modelValue: fileSource.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fileSource).value = $event)),
              size: "small",
              placeholder: "全部",
              style: {"width":"150px"},
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fileSources), (s, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: s,
                    value: s,
                    key: i
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_input, {
              modelValue: keyword.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((keyword).value = $event)),
              size: "small",
              placeholder: "名称/描述关键字",
              style: {"width":"200px"},
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (load()))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_7, "共 " + _toDisplayString(_unref(filteredFiles).length) + " 个附件", 1)
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _unref(filteredFiles),
          border: "",
          size: "small",
          "max-height": "520"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              width: "60",
              label: "序号",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "source",
              label: "附件来源",
              width: "110",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "filetype",
              label: "附件类型",
              width: "120",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "附件名称",
              "min-width": "240",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("a", {
                  href: `${api.value}${scope.row.url}`,
                  target: "_blank",
                  style: {"color":"#409EFF"}
                }, _toDisplayString(scope.row.name), 9, _hoisted_8)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "附件描述/日志内容",
              "min-width": "300"
            }, {
              default: _withCtx((scope) => [
                (scope.row.target)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "javascript:void(0)",
                      class: "desc-link",
                      title: '点击跳转到：'+targetName(scope.row.target),
                      onClick: ($event: any) => (goTarget(scope.row))
                    }, [
                      _createTextVNode(_toDisplayString(scope.row.desc) + " ", 1),
                      _hoisted_10
                    ], 8, _hoisted_9))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      title: scope.row.desc,
                      class: "desc-text"
                    }, _toDisplayString(scope.row.desc), 9, _hoisted_11))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "time",
              label: "时间",
              width: "150",
              align: "center"
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, loading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: taskShow.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((taskShow).value = $event)),
      "show-close": false,
      fullscreen: "",
      "append-to-body": ""
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (taskShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (taskShowInner.value)
          ? (_openBlock(), _createBlock(TaskDetails, {
              key: 0,
              form: taskForm.value,
              focusTarget: focusTarget.value,
              focusStepId: focusStepId.value,
              focusLogId: focusLogId.value,
              onTaskListsx: _cache[7] || (_cache[7] = ($event: any) => (taskShow.value=false))
            }, null, 8, ["form", "focusTarget", "focusStepId", "focusLogId"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: projectInfoShow.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((projectInfoShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false,
      width: "88%",
      top: "4vh",
      "append-to-body": ""
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", null, "项目信息 - " + _toDisplayString(curProject.value.projectname || pname.value), 1),
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (projectInfoShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (projectInfoShow.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (projectInfoShow.value)
          ? (_openBlock(), _createBlock(ProjectInfoEdit, {
              key: 0,
              ref_key: "projectInfoRef",
              ref: projectInfoRef,
              projectuuid: curProject.value.uuid || puuid.value,
              projectname: curProject.value.projectname || pname.value,
              projectcode: curProject.value.code || '',
              focusSection: "dc",
              onSaved: _cache[10] || (_cache[10] = ($event: any) => (projectInfoShow.value=false))
            }, null, 8, ["projectuuid", "projectname", "projectcode"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: projectLogShow.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((projectLogShow).value = $event)),
      "show-close": false,
      fullscreen: "",
      "append-to-body": ""
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (projectLogShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (projectLogShowInner.value)
          ? (_openBlock(), _createBlock(AddProjectlog, {
              key: 0,
              projectnr: curProject.value,
              focusLogId: focusProjectLogId.value
            }, null, 8, ["projectnr", "focusLogId"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})